/*global aps_directory_data */
/*eslint no-unused-vars: 0*/

// JS funcitonality for the homepage template

if (document.getElementById("staff-directory-container")) {
	(function ($) {
		"use strict";

		$(function () {
			// setup

			var directory_data = aps_directory_data,
				$container_controls = $("#sd-controls"),
				$container_content = $("#sd-content"),
				$search_by_school = $("#search_by_school"),
				$filter_lname,
				$filter_fname,
				$filter_team,
				$filter_cat,
				$filter_courses,
				tmpl_controls = _.template($("#template-controls").html()),
				tmpl_content = _.template($("#template-content").html()),
				tmpl_row = _.template($("#template-content-row").html());

			// logic

			setupControls();
			setupListings();

			function setupControls() {
				var department_options = reduceListToOptions(
						directory_data,
						"department"
					),
					category_options = reduceListToOptions(
						directory_data,
						"category"
					),
					data = {
						department_options: department_options,
						category_options: category_options,
					};

				$container_controls.html(tmpl_controls({ data: data }));

				$filter_fname = $("#filter_fname");
				$filter_lname = $("#filter_lname");
				$filter_team = $("#filter_team");
				$filter_cat = $("#filter_category");
				$filter_courses = $("#filter_courses");

				$container_controls.on(
					"keyup",
					"input[type=text]",
					function (ev) {
						setupListings();
					}
				);

				$container_controls.on("change", "select", function (ev) {
					setupListings();
				});

				$search_by_school.on("change", function (ev) {
					window.location = $(this).val();
				});
			}

			function setupListings() {
				var filtered_listings = applyFilters(directory_data);

				var listings = _.reduce(
					filtered_listings,
					function (markup, el) {
						return markup + tmpl_row({ data: el });
					},
					""
				);

				$container_content.html(
					tmpl_content({ data: { listings: listings } })
				);

				// check for a hash in the URL
				if (window.location.hash) {
					var hash = window.location.hash;

					// using jQuery to smoothly scroll to the id
					$("html, body").animate(
						{
							scrollTop: $(hash).offset().top,
						},
						800
					);
				}
			}

			// helper functions

			function applyFilters(data) {
				var output = data,
					fname_s = $filter_fname.val(),
					lname_s = $filter_lname.val(),
					team_s = $filter_team.val(),
					course_s = $filter_courses.val(),
					cat_s = $filter_cat.val();

				// filter by first name
				if ("undefined" != typeof fname_s && "" != fname_s) {
					output = _.filter(output, function (el) {
						return (
							el.name_f
								.toLowerCase()
								.indexOf(fname_s.toLowerCase()) > -1
						);
					});
				}

				// filter by last name
				if ("undefined" != typeof lname_s && "" != lname_s) {
					output = _.filter(output, function (el) {
						return (
							el.name_l
								.toLowerCase()
								.indexOf(lname_s.toLowerCase()) > -1
						);
					});
				}

				// filter by team
				if ("undefined" != typeof team_s && "" != team_s) {
					output = _.filter(output, function (el) {
						return (
							el.team
								.toLowerCase()
								.indexOf(team_s.toLowerCase()) > -1
						);
					});
				}

				// filter by course
				if ("undefined" != typeof course_s && "" != course_s) {
					output = _.filter(output, function (el) {
						if ("undefined" === typeof el.course) return false;
						var course_string = el.course.join(" ");
						return (
							course_string
								.toLowerCase()
								.indexOf(course_s.toLowerCase()) > -1
						);
					});
				}

				// filter category
				if ("" != cat_s) {
					output = _.filter(output, function (el) {
						return cat_s === el.category;
					});
				}

				// alphebetize:
				output = _.sortBy(output, function (el) {
					return el.name_l;
				});

				return output;
			}

			function reduceListToOptions(list, key) {
				var tmpl_option = _.template(
					"<option value='<%= value %>'><%= title %></option>"
				);

				return _.chain(list)
					.map(function (el) {
						return el[key];
					})
					.flatten()
					.uniq()
					.sortBy()
					.value()
					.reduce(function (markup, el) {
						return markup + tmpl_option({ value: el, title: el });
					}, "");
			}
		});
	})(jQuery);
}
